<ng-container *ngFor="let indication of indications">
    <app-indication-item
            [indication]="indication">
    </app-indication-item>
</ng-container>
